
import CoreService from "../../../../services/CoreService";
import LocalStorageService from "../../../../services/LocalStorageService";
import ObsSearchParams from "../../../../models/ObsSearchParams";
import ServiceDataResponse from "../../../../models/ServiceDataResponse";

import ObservationLotReportManager from "./ObservationLotReportManager";
import ObservationGenericReportManager from "./ObservationGenericReportManager";






export default class ReportDataFactory 
{
    // 
    static async ReportData(reportName, observation, uid, gcid, token, shared)
    {
        var localStorageService = new LocalStorageService();
        var coreService = new CoreService();

        if (reportName.toLowerCase() === "observation-std")
        {
            var gradeColorMapResult = await coreService.fetchIdNameDataList("colormap-grade", gcid, token);
            //if (shared)
            //{
           //     gradeColorMapResult = await coreService.fetchCo
            //}
            //var gradeColorMapResponse = localStorageService.getDataList("colormap-grade", gcid);
            var gradeColorMap = gradeColorMapResult.dataResult.data;
            var observations = [];
            observations.push(observation);
            var data = await ObservationLotReportManager.toReportData(reportName, observations, gradeColorMap, gcid, token);
            var result = new ServiceDataResponse(data, false, "standard report data")
            return result;
        }
        else if (reportName.toLowerCase() === "observation")
        {
            var gradeColorMapResult = await coreService.fetchIdNameDataList("colormap-grade", gcid, token);
            var gradeColorMap = gradeColorMapResult.dataResult.data;
            var observations = [];
            observations.push(observation);
            var data = await ObservationGenericReportManager.toReportData(reportName, observations, gradeColorMap, gcid);
            var result = new ServiceDataResponse(data, false, "standard report data")
            return result;
        }
        else if (reportName.toLowerCase() === "observation-lot")
        {
            var lotNumber = observation.data.Raw["famous-lot-number"];
            var gradeColorMapResult = await coreService.fetchIdNameDataList("colormap-grade", gcid, token);
            //var gradeColorMapResponse = localStorageService.getDataList("colormap-grade", gcid);
            var gradeColorMap = gradeColorMapResult.dataResult.data;
            //var schema = localStorageService.getSchema("ALL");
            var schemaResult = await coreService.fetchSchema("ALL", gcid, token);
            var schema = schemaResult.dataResult;
            var searchParams = new ObsSearchParams();
            searchParams.lot = lotNumber;
            searchParams.gcid = gcid;
            searchParams.location = observation.data.Raw.location;
            var observationListResponse = await new CoreService().fetchObservationList(searchParams, schema.search, gcid, token);
            if (observationListResponse.hasError) 
            {
                var errMsgs = observationListResponse.messages; 
                errMsgs.unshift("There was a problem fetching observations for the lot report.");
                var result = new ServiceDataResponse(null, true, errMsgs)
              return;
            }
            var observations = observationListResponse.dataResult;
            var data = await ObservationLotReportManager.toReportData(reportName, observations, gradeColorMap, gcid, token, shared);
            var result = new ServiceDataResponse(data, false, "Lot report data")
            return result;
        }
    } 




}


